export class PatientDataMissingError extends Error {
  constructor() {
    super(`Patient data missing.`);
  }
}
